export const DOMAIN_URL_HELPER_TEXT = "https://domain.com"
